const routes = [
  {
    path: '/at/equipment',
    name: 'equipments',
    component: () => import('@/views/at/equipment/Main.vue'),
  },
  {
    path: '/at/referral',
    name: 'referrals',
    component: () => import('@/views/at/referral/Main.vue'),
  },
  {
    path: '/at/referralcountstatus',
    name: 'referralcountstatus',
    component: () => import('@/views/at/referral-count-status/Main.vue'),
  },
  {
    path: '/at/appointment-report',
    name: 'appointmentreport',
    component: () => import('@/views/at/appointment-report/Main.vue'),
  },
]

export default routes
